import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ContextDetails from './ContextDetails'
import ContextTools from './tools/ContextTools'
import StudentIds from './tools/StudentIds'
import NewCourseModal from './NewCourseModal'
import { useStateValue } from '@State'

const ContextContainer = ({match}) => {
  const [newCourseModalOpen, toggleModal] = useState(false)
  const [currentState, dispatch] = useStateValue()

  const hideTools = () => {
    dispatch({
      type: 'hideContextTools',
      showContextTools: null,
    })
  }

  let contextTool = () => {
    switch (currentState.showContextTools) {
      case 'assessments':
        return <ContextTools contextId={match.params.contextId} />
      case 'students':
        return <StudentIds contextId={match.params.contextId} />
      default:
        return null
    }
  }

  return (
    <Fragment>
      <div className="card-myed">
        <div className="pull-right">
          <Link
            onClick={hideTools}
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4"
            to={`/account/admin_org_key_management/-/organizations/${match.params.orgId}/`}
          >
            <div className="fa-regular fa-arrow-circle-left fa-fw mr-2" /> Go Back
          </Link>
          <Link
            onClick={hideTools}
            className="me-btn me-btn-secondary me-btn-sm mr-4"
            to={`/account/admin_org_key_management/-/organizations/${match.params.orgId}/contexts/${match.params.contextId}/api-explorer`}
          >
            <i className="me-btn-glyph fa-regular fa-magnifying-glass" aria-hidden="true" />
            <span className="me-btn-label">Canvas API Explorer</span>
          </Link>
          <div
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
            onClick={() => toggleModal(!newCourseModalOpen)}
          >
            <div className="fa-regular fa-plus fa-fw mr-2" /> Add New Course
          </div>
        </div>
        <h3>Context Details</h3>
        <ContextDetails contextId={match.params.contextId} />
      </div>
      <NewCourseModal
        contextPk={match.params.contextId}
        show={newCourseModalOpen}
        toggle={toggleModal}
      />
      {contextTool()}
    </Fragment>
  )
}

ContextContainer.propTypes = {
  match: PropTypes.object,
}

export default ContextContainer
